"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var _get = require('lodash/get');
/**
 * Utility functions for the composition context.
 *
 * In order to allow replacement and disablement of certain components
 * we use the CompositionContext. These functions contain the logic for
 * handling which components should be replaced/disabled within a
 * customisable component.
 */
var CompositionUtil = /** @class */ (function () {
    function CompositionUtil() {
    }
    /**
     * Main function for handling compositions.
     *
     * Takes the composition context, the component to be checked, etc. and
     * either replaces, disables or returns the original component. Will also
     * inject the required functions and properties for the replaced components.
     *
     * @param options CompositionUtilOptions
     */
    CompositionUtil.handleComposition = function (options) {
        var composition = options.composition, path = options.path, propName = options.propName, propValue = options.propValue, defaultElement = options.defaultElement, onChange = options.onChange, onChangeName = options.onChangeName;
        var compositionValue = _get(composition, path);
        var globalPath = path.split('.')[path.split('.').length - 1];
        var globalComposition = _get(composition, globalPath);
        var injectOptions = {
            onChange: onChange,
            propName: propName,
            propValue: propValue,
            onChangeName: onChangeName
        };
        if (compositionValue !== undefined) {
            if (compositionValue !== false) {
                injectOptions.component = compositionValue;
                return CompositionUtil.injectProperties(injectOptions);
            }
            else {
                return null;
            }
        }
        if (globalComposition !== undefined) {
            if (globalComposition !== false) {
                injectOptions.component = globalComposition;
                return CompositionUtil.injectProperties(injectOptions);
            }
            else {
                return null;
            }
        }
        injectOptions.component = defaultElement;
        return CompositionUtil.injectProperties(injectOptions);
    };
    /**
     * Injects the value and onChange properties to a given component.
     *
     * @param options CompositionUtilInjectOptions
     */
    CompositionUtil.injectProperties = function (options) {
        var _a, _b;
        var component = options.component, onChange = options.onChange, propName = options.propName, propValue = options.propValue, onChangeName = options.onChangeName;
        if (onChangeName !== undefined && onChangeName !== '') {
            return (React.cloneElement(component, (_a = {}, _a[propName] = propValue, _a[onChangeName] = onChange, _a)));
        }
        return (React.cloneElement(component, (_b = {}, _b[propName] = propValue, _b.onChange = onChange, _b)));
    };
    return CompositionUtil;
}());
exports.default = CompositionUtil;
//# sourceMappingURL=CompositionUtil.js.map